import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";

interface InitialState {
    eventMapList: any;
    eventLatestSubstanceList: any;
    mapLoading: boolean;
    addMapLoading: boolean;    
    deleteMapLoading: boolean;    
  }

  const initialState: InitialState = {
    eventMapList: [],
    eventLatestSubstanceList: [],
    mapLoading: false,
    addMapLoading: false,    
    deleteMapLoading: false,    
  };

  const eventSlice = createSlice({
    name: "eventmap",
    initialState,
    reducers: {
        eventMapList: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            eventMapList: action.payload,
          }),
          setLoader: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            mapLoading: action.payload,
          }),
          setAddMapLoader: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            addMapLoading: action.payload,
          }),
          setDeleteMapLoader: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            deleteMapLoading: action.payload,
          }),
        eventLatestSubstance: (state: Draft<InitialState>, action: PayloadAction<any>) =>({
          ...state,
          eventLatestSubstanceList: action.payload,
        })
    }
  })
  
export const { eventMapList, setLoader,setAddMapLoader,setDeleteMapLoader, eventLatestSubstance } = eventSlice.actions;

export default eventSlice.reducer;